import 'firebase/functions';

import { message } from '@ssmm/ui';
import firebase from 'firebase/compat/app';
import {
  LANDING_CLOSE_TARIFFS,
  LANDING_CLOSE_VIDEO,
  LANDING_CLOSE_VIDEO_GALLERY,
  LANDING_OPEN_TARIFFS,
  LANDING_OPEN_VIDEO,
  LANDING_OPEN_VIDEO_GALLERY,
  LANDING_SET_CASES,
  LANDING_SET_MODULE_ID,
  LANDING_SET_REVIEW,
  LANDING_SET_REVIEWS,
} from 'redux/types';

import { openPdfModal } from '../../pdf-modal/actions';
import { cases, reviewAvatars } from '../settings';

export const openVideoGallery = () => ({ type: LANDING_OPEN_VIDEO_GALLERY });

export const closeVideoGallery = () => ({ type: LANDING_CLOSE_VIDEO_GALLERY });

export const selectModule = modId => ({ type: LANDING_SET_MODULE_ID, payload: modId });

export const openVideo = videoSourceId => ({ type: LANDING_OPEN_VIDEO, payload: videoSourceId });

export const closeVideo = () => ({ type: LANDING_CLOSE_VIDEO });

export const selectReview = index => ({ type: LANDING_SET_REVIEW, payload: index });

export const openTariffs = () => ({ type: LANDING_OPEN_TARIFFS });

export const closeTariffs = () => ({ type: LANDING_CLOSE_TARIFFS });

export const onLoad = () => async dispatch => {
  dispatch({ type: LANDING_SET_CASES, payload: cases });

  const getReviews = firebase.functions().httpsCallable('getReviews');

  const reviews = await getReviews({ offset: 0, limit: 1000000, extension: 'vkboss' }).then(res =>
    res.data.map(rawReview => ({
      title: rawReview.title,
      name: rawReview.user.name,
      rating: 5,
      about: rawReview.activity,
      review: rawReview.message,
      avatar: reviewAvatars[rawReview.token] || rawReview.user.photo,
      avatarLarge: reviewAvatars[rawReview.token] || rawReview.user.photo,
    }))
  );

  dispatch({ type: LANDING_SET_REVIEWS, payload: reviews });
};

export const inDevelopment = () => () => message.info('Функция в разработке');

export { openPdfModal };
